export const defaultLocale = 'cn';

export const supportedLocales = ['cn', 'en', 'jp', 'ko', 'yn'];

export const languageOptions = [
  {
    code: 'cn',
    name: '中文',
    nativeName: '中文',
    icon: require('@/assets/images/zh_cn.png'),
  },
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    icon: require('@/assets/images/zh_en.png'),
  },
  {
    code: 'jp',
    name: '日語',
    nativeName: '日語',
    icon: require('@/assets/images/zh_jpan.png'),
  },
  {
    code: 'ko',
    name: '한국어',
    nativeName: '한국어',
    icon: require('@/assets/images/zh_han.png'),
  },
  {
    code: 'yn',
    name: 'Tiếng Việt',
    nativeName: 'Tiếng Việt',
    icon: require('@/assets/images/zh_yn.png'),
  },
];

export function normalizeLocale(locale) {
  return supportedLocales.includes(locale) ? locale : defaultLocale;
}

export function getSavedLocale() {
  return normalizeLocale(localStorage.getItem('languageRadio') || defaultLocale);
}

export function setSavedLocale(locale) {
  const normalizedLocale = normalizeLocale(locale);
  localStorage.setItem('languageRadio', normalizedLocale);
  return normalizedLocale;
}
